//
//
//
//
//

import r_content from '../components/r_content.vue'
export default {
  components: {
    r_content
  }
}



// WEBPACK FOOTER //
// ./src/views/range.vue